var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup3324(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 39,
    viewBox: "0 0 26 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.05013,
    y: 1.06124,
    width: 11.3887,
    height: 15.7272,
    rx: 5.69433,
    fill: "#FD2242",
    stroke: "#FD2242",
    strokeWidth: 1.08463
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9468 32.2444V33.5601C24.9468 35.9784 22.9864 37.9388 20.5681 37.9388H4.92126C2.50297 37.9388 0.542561 35.9784 0.542561 33.5601V32.2444C0.542561 25.5054 6.00564 20.0423 12.7447 20.0423C19.4837 20.0423 24.9468 25.5054 24.9468 32.2444Z",
    fill: "#FD2242",
    stroke: "#FD2242",
    strokeWidth: 1.08463
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup3324);
export default __webpack_public_path__ + "static/media/Group 3324.791d6332a34dbd2de789ce1276e14bab.svg";
export { ForwardRef as ReactComponent };